import React, { MouseEvent, useCallback } from "react";

import classnames from "classnames";

import { IconProps, StarIcon } from "../icons";

type FavoriteProps = {
  id?: string;
  active?: boolean;
  /** If not passed the rendered element will not have "checkbox" role attribute */
  onClick?: (state: boolean, e: MouseEvent<HTMLDivElement>) => void;
  iconProps?: IconProps;
  iconClassName?: string;
};

const Favorite: React.FC<FavoriteProps> = ({
  id,
  active = false,
  onClick,
  iconProps = {},
  iconClassName,
}) => {
  const classNames = classnames(iconClassName, active && "text-warning-500");
  const className = classnames(
    iconProps?.className,
    "cursor-pointer",
    active && "fill-current"
  );

  const handleClick = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      if (onClick && typeof onClick === "function") onClick(!active, e);
    },
    [active, onClick]
  );

  return (
    <div
      id={id}
      role={onClick && typeof onClick === "function" ? "checkbox" : ""}
      aria-checked={
        onClick && typeof onClick === "function" ? active : undefined
      }
      tabIndex={0}
      onClick={handleClick}
      className={classNames}
    >
      <StarIcon {...iconProps} className={className} />
    </div>
  );
};

export default React.memo(Favorite);
